import React, { useEffect, useState } from "react";
import {
  getStationList,
  type Station,
  getPlantDetails,
  getStationDailyData,
} from "../utils/huaweiUtils";
import "../css/Huawei.css";
import HuaweiDailyChart from "../components/HuaweiDailyChart";
import { getMonthlyKpi } from "../utils/huaweiUtils";
import {
  Chart as ChartJS,
  BarElement,
  CategoryScale,
  LinearScale,
  Tooltip,
  Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";


const Huawei = ({ siteId }: any) => {
  const [stations, setStations] = useState<Station[]>([]);
  const [selectedPlantDetails, setSelectedPlantDetails] = useState<any>(null); // 🔍 nowy stan
  const [dailyData, setDailyData] = useState<any[]>([]);
  const [monthlyData, setMonthlyData] = useState<any[]>([]);
  const [showChart, setShowChart] = useState(false);

  ChartJS.register(BarElement, CategoryScale, LinearScale, Tooltip, Legend);

  useEffect(() => {
    if (!siteId || stations.length === 0) return;
  
    const matchedStation = stations.find((station) => station.plantCode === siteId);
  
    if (matchedStation) {
      handlePlantDetails(matchedStation.plantCode);
    }
  }, [siteId, stations]);
  
  useEffect(() => {
    const fetchStations = async () => {
      try {
        const data = await getStationList();
        setStations(data);
      } catch (error) {
        console.error("Błąd przy pobieraniu stacji:", error);
      }
    };

    fetchStations();
  }, []);

  const handlePlantDetails = async (plantCode: string) => {
    console.log("Wywołanie detali dla:", plantCode);
    try {
      const details = await getPlantDetails(plantCode);
      console.log("📊 Szczegóły instalacji:", details);
  
      if (Array.isArray(details) && details.length > 0) {
        setSelectedPlantDetails(details[0]); // 🔥 użyj tylko pierwszego elementu
      } else {
        setSelectedPlantDetails(null);
      }
    } catch (error) {
      console.error("Błąd przy pobieraniu detali:", error);
    }
  };

  const fetchDailyProduction = async (plantCode: string) => {
    try {
      const data = await getStationDailyData(plantCode);
      console.log("📈 Dane dzienne:", data);
      setDailyData(data || []);
    } catch (error) {
      console.error("Błąd przy pobieraniu danych dziennych:", error);
    }
  };

  const fetchMonthlyData = async (plantCode: string) => {
    try {
      const res = await getMonthlyKpi(plantCode);
      console.log("📆 Monthly KPI:", res);
      setMonthlyData(res);
      setShowChart(true);
    } catch (error) {
      console.error("Błąd przy pobieraniu danych miesięcznych:", error);
    }
  };

  return (
    <div id="Huawei">
      <header className="Se-header">Monitoring Huawei</header>

      {/* 🔝 Szczegóły wybranej instalacji */}
      {selectedPlantDetails && (
        <div className="plant-details-box">
          <h3>Szczegóły instalacji: {selectedPlantDetails.stationCode}</h3>
          <table className="huawei-details-table">
            <tbody>
              <tr>
                <td><strong>Moc całkowita:</strong></td>
                <td>{selectedPlantDetails.dataItemMap.total_power} kW</td>
              </tr>
              <tr>
                <td><strong>Produkcja dzisiaj:</strong></td>
                <td>{selectedPlantDetails.dataItemMap.day_power} kWh</td>
              </tr>
              <tr>
                <td><strong>Produkcja w tym miesiącu:</strong></td>
                <td>{selectedPlantDetails.dataItemMap.month_power} kWh</td>
              </tr>
            </tbody>
          </table>
          <button
            style={{ marginTop: "10px" }}
            onClick={() => fetchDailyProduction(selectedPlantDetails.stationCode)}
          >
            Pokaż produkcję dzienną
          </button>
          {/* <button onClick={() => fetchMonthlyData(selectedPlantDetails.stationCode)}>
            📈 Pokaż dane miesięczne
          </button> */}
        </div>
      )}
      {dailyData.length > 0 && (
        <div style={{ marginTop: "20px" }}>
          <HuaweiDailyChart data={dailyData} />
        </div>
      )}

      {showChart && monthlyData.length > 0 && (
        <div style={{ maxWidth: "600px", marginTop: "20px" }}>
          <Bar
            data={{
              labels: monthlyData.map((item: any) => item.collectTime),
              datasets: [
                {
                  label: "Produkcja energii [kWh]",
                  data: monthlyData.map((item: any) => item.dataItemMap.month_power),
                  backgroundColor: "rgba(75,192,192,0.6)",
                },
              ],
            }}
            options={{
              responsive: true,
              plugins: {
                legend: { display: true },
              },
              scales: {
                x: {
                  title: { display: true, text: "Data" },
                },
                y: {
                  title: { display: true, text: "kWh" },
                  beginAtZero: true,
                },
              },
            }}
          />
        </div>
      )}

      <table className="huawei-table">
        <thead>
          <tr>
            <th>Nazwa</th>
            <th>Kod</th>
            <th>Moc</th>
            <th>Akcje</th>
          </tr>
        </thead>
        <tbody>
          {stations.map((station, index) => (
            <tr key={index}>
              <td>{station.plantName}</td>
              <td>{station.plantCode}</td>
              <td>{station.capacity}</td>
              <td>
                <button onClick={() => handlePlantDetails(station.plantCode)}>
                  Więcej informacji
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default Huawei;
